import { P as Pagination } from './swiper-pagination.js';
import { S as Swiper } from './swiper-index.js';
import './swiper-classes-to-selector.js';
import './swiper-create-element.js';
import './swiper-core.js';
import './swiper-a11y.js';

class StatsCardSwiper extends HTMLElement {
  connectedCallback() {
    this.swiper = Swiper(this, {
      modules: [Pagination],
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        bulletElement: 'button',
      },
      a11y: {
        slideRole: 'listitem',
      },
    });
  }
}

customElements.define('stats-card-swiper', StatsCardSwiper);
